module.exports = __webpack_public_path__ + "static/media/RELEASE_NOTES.71b42179.md";